import React from 'react';
import { inject, observer } from 'mobx-react';
import s from './index.less';
import { useIntl } from 'umi';
interface ConnectErrorProps {
  onConnect?: any;
}

const ConnectError: React.FC<ConnectErrorProps> = inject()(
  observer((props: ConnectErrorProps) => {
    const { onConnect } = props;
    const { formatMessage } = useIntl();
    return (
      <div className={s.container}>
        <span className={s.text}> {formatMessage({ id: 'subtitleStatus' })}</span>
        <span className={s.retry} onClick={onConnect}>
          {formatMessage({ id: 'TRY_AGAIN' })}
        </span>
      </div>
    );
  })
);

export default ConnectError;
